import { createApp } from "vue";
import App from "./App.vue";
import Aura from "@primeuix/themes/aura";
import PrimeVue from "primevue/config";
import { definePreset } from "@primeuix/themes";
import router from "@router";
import { createPinia } from "pinia";
import Tooltip from "primevue/tooltip";

const pinia = createPinia();

import VueTelInput from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";

/* add fontawesome core */
import "primeicons/primeicons.css";
import { library } from "@fortawesome/fontawesome-svg-core";
/* import all the icons in Free Solid, Free Regular, and Brands styles */
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fr } from "@lang/fr.js";
import { createI18n } from "vue-i18n";
import { createHead } from "@unhead/vue/client";
import { useTitle } from "./store/titleStore";
import { VueHeadMixin } from "@unhead/vue";
import ToastService from 'primevue/toastservice';

library.add(fas, far, fab);
const app = createApp(App);
const MyPreset = definePreset(Aura, {
	semantic: {
		primary: {
			50: "#E4EEF3",
			100: "#C9DDE7",
			200: "#9DC3D4",
			300: "#6FA7C0",
			400: "#418DAD",
			500: "#174F6C",
			600: "#13445D",
			700: "#103B50",
			800: "#0C3041",
			900: "#081F2C",
		},
	},
});

const i18n = createI18n({
	locale: navigator.language,
	fallbackLocale: "fr",
	fallbackWarn: false,
	missingWarn: false,
	silentTranslationWarn: true,
	silentFallbackWarn: true,
	messages: {
		fr: fr,
	},
});

const head = createHead();
// Définir un template de titre global
head.push({
	titleTemplate: (title) => {
		if (!title || title.trim() === "") {
			return "CITES";
		}
		const t = i18n.global.t;
		return `${t(title)} | CITES`;
	},
});

head.hooks.hook("entries:updated", (head) => {
	for (const [clé, valeur] of head.entries) {
		if (valeur.input.title) {
			useTitle().setTitle(valeur.input.title, i18n.global.t);
		}
	}
});

app.use(PrimeVue, {
	theme: {
		preset: MyPreset,
		options: {
			prefix: "p",
			darkModeSelector: ".my-app-dark",
			cssLayer: {
				name: "primevue",
				order: "theme, base, primevue",
			},
		},
	},
	locale: {
		dayNames: [
			"Dimanche",
			"Lundi",
			"Mardi",
			"Mercredi",
			"Jeudi",
			"Vendredi",
			"Samedi",
		],
		dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
		dayNamesMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
		monthNames: [
			"Janvier",
			"Février",
			"Mars",
			"Avril",
			"Mai",
			"Juin",
			"Juillet",
			"Aout",
			"Septembre",
			"Octobre",
			"Novembre",
			"Décembre",
		],
		monthNamesShort: [
			"Jan",
			"Fev",
			"Mar",
			"Avr",
			"Mai",
			"Jui",
			"Jul",
			"Aou",
			"Sep",
			"Oct",
			"Nov",
			"Dec",
		],
		today: "Aujourd'hui",
		weekHeader: "Wk",
		firstDayOfWeek: 1,
		clear: "Effacer",
	},
});
app.directive("tooltip", Tooltip);
app.use(i18n);
app.use(head);
app.use(router);
app.use(pinia);
app.use(VueTelInput, {
	mode: "international",
	defaultCountry: "FR",
	dropdownOptions: {
		showDialCodeInSelection: true,
	},
});
app.use(ToastService)
app.mixin(VueHeadMixin);

app.mount("#app");
